/**
 * Created by jonas on 2022-10-27.
 */
import {BS2} from "../BS2";
import {BS2GameMode} from "../server/BS2GameMode";
import {BS2Statics} from "../config/BS2Statics";
import {BS2Symbol, BS2SymbolStates} from "../reels/BS2Symbol";
import {replaceWithNewSymbolDataType, SpinMode} from "../server/BS2Data";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {WildSymbol} from "../reels/WildSymbol";
import {SanityCheckPresentation} from "../runnerpresentations/maingame/win/SanityCheckPresentation";

export class RestoreUtils {

    constructor() {

    }

    private static restoreBottomStickyWilds(callFromAS: boolean, isRestore: boolean): void {
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            if (checkIfWild(reelIdx)) {
                BS2.reelView.bottomStickyWildView.removeStickyWild(reelIdx, false, 0.3, true).progress(1);
                if (BS2.reelView.reels[reelIdx].model.getAllVisibleSymbols()[BS2Statics.BOT_STICKY_WILD_IDX_VIS_AREA].name !== BS2Statics.SYMBOLS.W) {
                    const data: replaceWithNewSymbolDataType = BS2.reelView.reels[reelIdx].model.replaceWithNewSymbol(BS2Statics.BOT_STICKY_WILD_IDX_WITH_BUFFER, BS2Statics.SYMBOLS.W);
                    (<BS2Symbol>data.newSymbol.positionable).setMultiplier((<BS2Symbol>data.oldSymbol.positionable).currMultiValue);
                    (<BS2Symbol>data.oldSymbol.positionable).destroy();
                }
            } else if (BS2.model.initReels[reelIdx][BS2Statics.BOT_STICKY_WILD_IDX_WITH_BUFFER] !== BS2Statics.SYMBOLS.Y) {
                BS2.reelView.bottomStickyWildView.removeStickyWild(reelIdx, false, 0.3, true).progress(1);
            } else {
                BS2.reelView.bottomStickyWildView.lockStickyWildTree(reelIdx, 0.3, true).progress(1);
            }
        }

        function checkIfWild(reelIdx: number): boolean {
            const isNextAvalanche: boolean = BS2.model.data.nextMode.includes("AVALANCHE");
            const reel: string[] = isNextAvalanche ? BS2.model.data.reelsAfterCollapse[reelIdx] : BS2.model.initReels[reelIdx],
                lastCheckIdx: number = isNextAvalanche ? reel.length : reel.length - 1,
                startCheckIdx: number = isNextAvalanche ? 0 : 1;
            let wildCountInReel: number = 0;
            let stickyWildCountInReel: number = 0;
            if ((isRestore || callFromAS) && reel[lastCheckIdx - 1] === "W") {
                return true;
            }
            if (isRestore || callFromAS) {
                for (let symIdx: number = startCheckIdx; symIdx < lastCheckIdx - 1; symIdx++) {
                    if (BS2Statics.SPLIT_SYMBOLS.includes(reel[symIdx]) || reel[symIdx] === "W") {
                        wildCountInReel++;
                    }
                }
                for (let symIdx: number = 0; symIdx < BS2.model.data.reelsAfterCollapse[reelIdx].length; symIdx++) {
                    if (BS2.model.data.reelsAfterCollapse[reelIdx][symIdx] === "W") {
                        stickyWildCountInReel++;
                    }
                }
            }

            if (wildCountInReel > 0) {
                return wildCountInReel > 0 && (stickyWildCountInReel > wildCountInReel);
            } else {
                return BS2.model.data.reelsAfterCollapse && BS2.model.data.reelsAfterCollapse[reelIdx][BS2Statics.BOT_STICKY_WILD_IDX_VIS_AREA] === "W";
            }
        }
    }

    private static initSymSizes(callFromAs: boolean = false): void {
        const symSize: number[][] = BS2.model.nextSpinMode() === SpinMode.AVALANCHE ?
            (callFromAs ? BS2.model.gameData.symbolSizesAfterCollapse : BS2.model.initData.symbolSizesAfterCollapse) :
            (callFromAs ? BS2.model.gameData.symbolSizes : BS2.model.initData.symbolSizes);
        const splitDirection: number[][] = BS2.model.nextSpinMode() === SpinMode.AVALANCHE ?
            (callFromAs ? BS2.model.gameData.splitDirectionsAfterCollapse : BS2.model.initData.splitDirectionsAfterCollapse) :
            (callFromAs ? BS2.model.gameData.splitDirections : BS2.model.initData.splitDirections)
        for (let i: number = 0; i < symSize.length; i++) {
            for (let j: number = 0; j < symSize[i].length; j++) {
                if (symSize[i][j] > 1) {
                    const symbolData: SimpleReelModelSymbolData = BS2.reelView.getVisibleSymbolDataAt(i, j);
                    const symbol: BS2Symbol = <BS2Symbol>symbolData.positionable;
                    if (!symbolData.removed) {
                        let splitDirectionString: "vertical" | "horizontal" | "cross" | undefined = undefined;
                        if (splitDirection[i][j] === -1 || (BS2Statics.SPLIT_SYMBOLS.includes(symbol.name) || symbol.name === BS2Statics.SYMBOLS.W)) {
                            splitDirectionString = undefined;
                        } else if (splitDirection[i][j] === 0) {
                            splitDirectionString = "horizontal";
                        } else if (splitDirection[i][j] === 1) {
                            splitDirectionString = "vertical";
                        } else if (splitDirection[i][j] === 2) {
                            splitDirectionString = "cross";
                        }
                        symbol.getMultiplierUpdateAnimation(symSize[i][j], splitDirectionString, true).progress(1);
                    }
                }
            }
        }
    }

    private static convertSplitSymToWild(): void {
        const allSymbols = BS2.reelView.getAllVisibleSymbols();
        allSymbols.forEach((ele) => {
            if (ele.name === BS2Statics.SYMBOLS.G || ele.name === BS2Statics.SYMBOLS.D) {
                const replacedData = BS2.reelView.reels[ele.reelId].model.replaceWithNewSymbol(ele.reelPosition + 1, BS2Statics.SYMBOLS.W);
                (<BS2Symbol>replacedData.oldSymbol.positionable).destroy();
                (<WildSymbol>replacedData.newSymbol.positionable).getStickyAnimation().progress(1);
            }
        });
    }

    private static playWildIdleAnimation(): void {
        if (BS2.model.initData.isRestoreState) {
            for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
                BS2.reelView.reels[reelIdx].model.getAllVisibleSymbols().forEach((sym) => {
                    if (sym.name === BS2Statics.SYMBOLS.W) {
                        (<WildSymbol>sym.positionable).getStickyAnimation();
                    }
                })
            }
        }
    }

    private static convertMidToHighEleminateLow(): void {
        if (BS2.model.data.upgradeLevel && BS2.model.nextSpinMode() === SpinMode.SPIN) {
            for (let reelidx: number = 0; reelidx < BS2Statics.NR_OF_REELS; reelidx++) {
                const symbols: SimpleReelModelSymbolData[] = BS2.reelView.reels[reelidx].model.getAllVisibleSymbols();
                for (let symIdx: number = 0; symIdx < symbols.length; symIdx++) {
                    if (!BS2Statics.HIGH_SYMBOLS.includes(symbols[symIdx].name)) {
                        const num: number = getSymSecCharToNumber(symbols[symIdx].name[1]);
                        if (checkToPerform(num)) {
                            if (BS2Statics.LOW_SYMBOLS.includes(symbols[symIdx].name)) {
                                (<BS2Symbol>symbols[symIdx].positionable).getStateAnimation(BS2SymbolStates.UPGRADE_DEAD).progress(1);
                            } else if (BS2Statics.MID_SYMBOLS.includes(symbols[symIdx].name)) {
                                const replaceData: replaceWithNewSymbolDataType = BS2.reelView.reels[reelidx].model.replaceWithNewSymbol(symIdx + 1, "H" + num);
                                (<BS2Symbol>replaceData.oldSymbol.positionable).destroy();
                            }
                        }
                    }
                }
            }

            function checkToPerform(symSecondChar: number): boolean {
                if (BS2.model.data.nextLevel === 1) {
                    return symSecondChar === 5;
                } else if (BS2.model.data.nextLevel === 2) {
                    return symSecondChar >= 4;
                } else if (BS2.model.data.nextLevel === 3) {
                    return symSecondChar >= 3;
                } else if (BS2.model.data.nextLevel === 4) {
                    return symSecondChar >= 2;
                } else if (BS2.model.data.nextLevel === 5) {
                    return symSecondChar >= 1;
                }
                return false
            }

            function getSymSecCharToNumber(symSecondChar: string): number {
                switch (symSecondChar) {
                    case "1":
                        return 1;
                    case "2":
                        return 2;
                    case "3":
                        return 3;
                    case "4":
                        return 4;
                    default:
                        return 5;
                }
            }
        }
    }

    private static resetSpinesForAS(): void {
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            const visSym: SimpleReelModelSymbolData[] = BS2.reelView.reels[reelIdx].model.getAllVisibleSymbols();
            for (let symIdx: number = 0; symIdx < visSym.length; symIdx++) {
                (<BS2Symbol>visSym[symIdx].positionable).resetSpineForAS();
            }
        }
    }

    public static startupGame(isRestore: boolean, callFromAS: boolean = false) {
        //Same for all
        BS2.backgroundElements.switchLevel(BS2.model.data.nextLevel, true, true).progress(1);
        if (callFromAS) {
            BS2.model.initReels = BS2.model.handleScatterOnRestore(BS2.model.gameData.reels, BS2.model.gameData.nextLevel);
            BS2.reelView.collectBar.resetAllSigillSpines();
            //reset bottom sticky wild fire animation
            for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
                BS2.reelView.bottomStickyWildView.resetStickyWildFireAnimOnBet(reelIdx);
            }
        }
        if (isRestore || callFromAS) {
            //Same for all restore
            BS2.keypadPlugin.setWin(BS2.model.data.accumulatedRoundWin, true, BS2.isWinBelowStake());
            if (BS2.model.isNextSuperFreespin()) {
                if (!BS2.model.isSuperFreespin()) {
                    RestoreUtils.restoreSuperFreespinWithIntro(BS2.model.nextSpinMode());
                } else {
                    RestoreUtils.restoreSuperFreespin(BS2.model.nextSpinMode());
                }
            } else if (BS2.model.isNextFreeSpin()) {
                RestoreUtils.restoreFreespin(BS2.model.nextSpinMode());
            } else if (BS2.model.data.nextMode == BS2GameMode.AVALANCHE_NORMAL) {
                RestoreUtils.restoreDuringAvalanche(BS2.model.nextSpinMode())
            }
            this.resetSpinesForAS();
            this.convertSplitSymToWild();
            this.convertMidToHighEleminateLow();
            this.initSymSizes(callFromAS);
        } else {
            RestoreUtils.normalStartUp();
        }
        this.restoreBottomStickyWilds(callFromAS, isRestore);
        if (isRestore || callFromAS) {
            BS2.reelView.collectBar.setValue(BS2.model.data.totalCollectedSymbols, false, false, false, false, true).progress(1);
        }
        this.playWildIdleAnimation();
        if (isRestore || callFromAS && SanityCheckPresentation.run) {
            SanityCheckPresentation.checkFinalSymbolSizes(BS2.model.data.nextMode.indexOf("AVALANCHE") > -1 ? BS2.model.data.symbolSizesAfterCollapse : BS2.model.data.symbolSizes, "SanityCheckPresentation");
            // SanityCheckPresentation.checkSymNames(BS2.model.data.nextMode.indexOf("AVALANCHE") > -1 ? BS2.model.data.reelsAfterCollapse : BS2.model.data.reels);
        }
    }

    public static restoreAfterMaxWin(spinMode: SpinMode) {
        BS2.reelView.initReels(BS2.NO_WIN_DATA.reels, 5, spinMode === SpinMode.AVALANCHE);
        BS2.keypadPlugin.setWin(BS2.model.data.accumulatedRoundWin, true, BS2.isWinBelowStake());
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            BS2.reelView.bottomStickyWildView.showStickyWild(reelIdx, 0.001, true).progress(1);
        }
        BS2.reelView.collectBar.resetToZero();
        BS2.backgroundElements.switchLevel(0);
    }

    public static restoreDuringAvalanche(spinMode: SpinMode) {
        BS2.reelView.initReels(spinMode === SpinMode.AVALANCHE ? BS2.model.data.reelsAfterCollapse : BS2.model.initReels, 5, spinMode === SpinMode.AVALANCHE);
    }

    public static restoreSuperFreespinWithIntro(spinMode: SpinMode) {
        BS2.reelView.initReels(spinMode === SpinMode.AVALANCHE ? BS2.model.data.reelsAfterCollapse : BS2.model.initReels, 5, spinMode === SpinMode.AVALANCHE);
        BS2.reelView.setReeSet(BS2Statics.LEVEL_REEL_SETS[4]);
        BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft);
    }

    public static restoreSuperFreespin(spinMode: SpinMode) {
        BS2.reelView.initReels(spinMode === SpinMode.AVALANCHE ? BS2.model.data.reelsAfterCollapse : BS2.model.initReels, 5, spinMode === SpinMode.AVALANCHE);
        BS2.reelView.setReeSet(BS2Statics.LEVEL_REEL_SETS[5]);
        BS2.reelView.collectBar.hide(0);
    }

    public static restoreFreespin(spinMode: SpinMode) {
        BS2.reelView.initReels(spinMode === SpinMode.AVALANCHE ? BS2.model.data.reelsAfterCollapse : BS2.model.initReels, 5, spinMode === SpinMode.AVALANCHE);
        BS2.reelView.setReeSet(BS2Statics.LEVEL_REEL_SETS[BS2.model.data.currentLevel]);
    }

    public static normalStartUp() {
        BS2.reelView.collectBar.resetToZero();
        BS2.reelView.initReels(BS2.model.initReels, 5, BS2.model.nextSpinMode() === SpinMode.AVALANCHE);
        for (let reelIdx: number = 0; reelIdx < BS2Statics.NR_OF_REELS; reelIdx++) {
            BS2.reelView.bottomStickyWildView.lockStickyWildTree(reelIdx).progress(1);
        }
    }

}